// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var MICROSOFT_APPLICATIONINSIGHTS_NAME = "Microsoft.ApplicationInsights.";
var MICROSOFT_DOT = "microsoft.";
var CLIENT_DOT = "client.";
var HTTP_DOT = "http.";
var NET_DOT = "net.";
var PEER_DOT = "peer.";
var EXCEPTION_DOT = "exception.";
var ENDUSER_DOT = "enduser.";
var URL_DOT = "url.";
var DB_DOT = "db.";
var NETWORK_DOT = "network.";
export var AzureMonitorSampleRate = MICROSOFT_DOT + "sample_rate";
export var ApplicationInsightsCustomEventName = MICROSOFT_DOT + "custom_event.name";
export var MicrosoftClientIp = MICROSOFT_DOT + CLIENT_DOT + "ip";
export var ApplicationInsightsMessageName = MICROSOFT_APPLICATIONINSIGHTS_NAME + "Message";
export var ApplicationInsightsExceptionName = MICROSOFT_APPLICATIONINSIGHTS_NAME + "Exception";
export var ApplicationInsightsPageViewName = MICROSOFT_APPLICATIONINSIGHTS_NAME + "PageView";
export var ApplicationInsightsAvailabilityName = MICROSOFT_APPLICATIONINSIGHTS_NAME + "Availability";
export var ApplicationInsightsEventName = MICROSOFT_APPLICATIONINSIGHTS_NAME + "Event";
export var ApplicationInsightsBaseType = "_MS.baseType";
export var ApplicationInsightsMessageBaseType = "MessageData";
export var ApplicationInsightsExceptionBaseType = "ExceptionData";
export var ApplicationInsightsPageViewBaseType = "PageViewData";
export var ApplicationInsightsAvailabilityBaseType = "AvailabilityData";
export var ApplicationInsightsEventBaseType = "EventData";
export var ATTR_ENDUSER_ID = ENDUSER_DOT + "id";
export var ATTR_ENDUSER_PSEUDO_ID = ENDUSER_DOT + "pseudo_id";
export var ATTR_HTTP_ROUTE = HTTP_DOT + "route";
export var SEMATTRS_NET_PEER_IP = NET_DOT + PEER_DOT + "ip";
export var SEMATTRS_NET_PEER_NAME = NET_DOT + PEER_DOT + "name";
export var SEMATTRS_NET_HOST_IP = NET_DOT + "host.ip";
export var SEMATTRS_PEER_SERVICE = PEER_DOT + "service";
export var SEMATTRS_HTTP_USER_AGENT = HTTP_DOT + "user_agent";
export var SEMATTRS_HTTP_METHOD = HTTP_DOT + "method";
export var SEMATTRS_HTTP_URL = HTTP_DOT + "url";
export var SEMATTRS_HTTP_STATUS_CODE = HTTP_DOT + "status_code";
export var SEMATTRS_HTTP_ROUTE = HTTP_DOT + "route";
export var SEMATTRS_HTTP_HOST = HTTP_DOT + "host";
export var SEMATTRS_DB_SYSTEM = DB_DOT + "system";
export var SEMATTRS_DB_STATEMENT = DB_DOT + "statement";
export var SEMATTRS_DB_OPERATION = DB_DOT + "operation";
export var SEMATTRS_DB_NAME = DB_DOT + "name";
export var SEMATTRS_RPC_SYSTEM = "rpc.system";
export var SEMATTRS_RPC_GRPC_STATUS_CODE = "rpc.grpc.status_code";
export var SEMATTRS_EXCEPTION_TYPE = EXCEPTION_DOT + "type";
export var SEMATTRS_EXCEPTION_MESSAGE = EXCEPTION_DOT + "message";
export var SEMATTRS_EXCEPTION_STACKTRACE = EXCEPTION_DOT + "stacktrace";
export var SEMATTRS_HTTP_SCHEME = HTTP_DOT + "scheme";
export var SEMATTRS_HTTP_TARGET = HTTP_DOT + "target";
export var SEMATTRS_HTTP_FLAVOR = HTTP_DOT + "flavor";
export var SEMATTRS_NET_TRANSPORT = NET_DOT + "transport";
export var SEMATTRS_NET_HOST_NAME = NET_DOT + "host.name";
export var SEMATTRS_NET_HOST_PORT = NET_DOT + "host.port";
export var SEMATTRS_NET_PEER_PORT = NET_DOT + PEER_DOT + "port";
export var SEMATTRS_HTTP_CLIENT_IP = HTTP_DOT + "client_ip";
export var SEMATTRS_ENDUSER_ID = ENDUSER_DOT + "id";
export var ATTR_CLIENT_ADDRESS = CLIENT_DOT + "address";
export var ATTR_CLIENT_PORT = CLIENT_DOT + "port";
export var ATTR_SERVER_ADDRESS = "server.address";
export var ATTR_SERVER_PORT = "server.port";
export var ATTR_URL_FULL = URL_DOT + "full";
export var ATTR_URL_PATH = URL_DOT + "path";
export var ATTR_URL_QUERY = URL_DOT + "query";
export var ATTR_URL_SCHEME = URL_DOT + "scheme";
export var ATTR_ERROR_TYPE = "error.type";
export var ATTR_NETWORK_LOCAL_ADDRESS = NETWORK_DOT + "local.address";
export var ATTR_NETWORK_LOCAL_PORT = NETWORK_DOT + "local.port";
export var ATTR_NETWORK_PROTOCOL_NAME = NETWORK_DOT + "protocol.name";
export var ATTR_NETWORK_PEER_ADDRESS = NETWORK_DOT + PEER_DOT + "address";
export var ATTR_NETWORK_PEER_PORT = NETWORK_DOT + PEER_DOT + "port";
export var ATTR_NETWORK_PROTOCOL_VERSION = NETWORK_DOT + "protocol.version";
export var ATTR_NETWORK_TRANSPORT = NETWORK_DOT + "transport";
export var ATTR_USER_AGENT_ORIGINAL = "user_agent.original";
export var ATTR_HTTP_REQUEST_METHOD = HTTP_DOT + "request.method";
export var ATTR_HTTP_RESPONSE_STATUS_CODE = HTTP_DOT + "response.status_code";
export var ATTR_EXCEPTION_TYPE = EXCEPTION_DOT + "type";
export var ATTR_EXCEPTION_MESSAGE = EXCEPTION_DOT + "message";
export var ATTR_EXCEPTION_STACKTRACE = EXCEPTION_DOT + "stacktrace";
export var EXP_ATTR_ENDUSER_ID = ENDUSER_DOT + "id";
export var EXP_ATTR_ENDUSER_PSEUDO_ID = ENDUSER_DOT + "pseudo_id";
export var EXP_ATTR_SYNTHETIC_TYPE = "synthetic.type";
export var DBSYSTEMVALUES_MONGODB = "mongodb";
export var DBSYSTEMVALUES_COSMOSDB = "cosmosdb";
export var DBSYSTEMVALUES_MYSQL = "mysql";
export var DBSYSTEMVALUES_POSTGRESQL = "postgresql";
export var DBSYSTEMVALUES_REDIS = "redis";
export var DBSYSTEMVALUES_DB2 = "db2";
export var DBSYSTEMVALUES_DERBY = "derby";
export var DBSYSTEMVALUES_MARIADB = "mariadb";
export var DBSYSTEMVALUES_MSSQL = "mssql";
export var DBSYSTEMVALUES_ORACLE = "oracle";
export var DBSYSTEMVALUES_SQLITE = "sqlite";
export var DBSYSTEMVALUES_OTHER_SQL = "other_sql";
export var DBSYSTEMVALUES_HSQLDB = "hsqldb";
export var DBSYSTEMVALUES_H2 = "h2";
//# sourceMappingURL=SemanticConventions.js.map